import createTableStore from "ds/components/Table/store/useTableStore";

import { PLUGIN_TEMPLATES_COLUMN_CONFIG, PLUGIN_TEMPLATES_COLUMNS_STORAGE_KEY } from "./constants";

export const usePluginTemplatesTableStore = createTableStore({
  storageKey: PLUGIN_TEMPLATES_COLUMNS_STORAGE_KEY,
  config: PLUGIN_TEMPLATES_COLUMN_CONFIG,
});
